module.exports = __webpack_public_path__ + "img/微信.37678280.png";